import {Injectable, EventEmitter, Output} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class LoginService {
    @Output() getLoggedInRole: EventEmitter<any> = new EventEmitter();
    user: any;
    public authToken: string;
    public role: string;
    public id: string;
    public email:string;

    constructor(private httpmanagerService: HttpManagerService) {
    }


    public storeUserData(token,role,id,email) {
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
        localStorage.setItem('id', id);
        localStorage.setItem('email',email)
        this.authToken = token;
        this.role = role;
    }
    loginUser(user): Promise<any> {
        return this.httpmanagerService.HttpPost('user/login', JSON.stringify(user), "").then(data => {

            this.getLoggedInRole.emit(data.role)
            return data;
        });
    }
    /*loginUser(user) {
        return this.http.post(this.registerUrl + 'user/login', JSON.stringify(user), this.options).map(
            (res: Response) => res.json());
    }*/
    public loadToken() {
        const token = localStorage.getItem('token');
        this.authToken = token;
        const rrole = localStorage.getItem('role');
        this.role = rrole;
        const rid = localStorage.getItem('id');
        this.id = rid;
        const remail=localStorage.getItem('email');
        this.email=remail
    }

    public returnToken(): string {
        if (this.authToken != null) {
            return this.authToken.toString();
        }
        return "";
    }

    public logout() {
        localStorage.removeItem('role');
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('email')
        localStorage.clear();
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/login/login.service.ts